import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const getUsers = async () => {
    const { data } = await axios.get(API_ROUTES.USERS);
    return data;
};

export const suspendUser = async (id, suspended) => {
    await axios.put(`${API_ROUTES.USER_SUSPEND}/${id}`, { suspended });
};

export const softDeleteUser = async (id) => {
    await axios.put(`${API_ROUTES.USER_DELETE}/${id}`);
};